import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "11",
  viewBox: "0 0 10 11",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.74716 2.58146H1.24716C1.17122 2.5817 1.09679 2.60264 1.03188 2.64203C0.966958 2.68143 0.914015 2.73778 0.878742 2.80502C0.84347 2.87227 0.827205 2.94786 0.831697 3.02366C0.83619 3.09946 0.861271 3.1726 0.904241 3.23521L4.65424 8.65188C4.80966 8.87646 5.18382 8.87646 5.33966 8.65188L9.08966 3.23521C9.13306 3.17273 9.15852 3.09956 9.16325 3.02363C9.16799 2.9477 9.15183 2.87193 9.11653 2.80454C9.08122 2.73715 9.02813 2.68073 8.96301 2.6414C8.89788 2.60207 8.82323 2.58134 8.74716 2.58146Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }